import { MenuItem } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

/**
 * @typedef {Object} ChakraMenuItemProps
 * @property {import('react').ReactNode} children
 * @param {import('@chakra-ui/react').MenuItemProps} props
 */
export default function ChakraMenuItem({ children, ...props }) {
    const { darkMode } = useSelector((state) => state.settings);
    const darkHoverBg = 'rgba(255, 255, 255, 0.12)';
    return (
        <MenuItem
            _focus={{
                bg: darkMode ? darkHoverBg : null,
            }}
            _hover={{
                bg: darkMode ? darkHoverBg : null,
            }}
            {...props}>
            {children}
        </MenuItem>
    );
}
